import * as React from 'react';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import ProfileImage from '../tabs/customer/ProfileImage';

const flexStyles = {
  display: 'flex',
  width: 'max-content',
};

const CustomerCard = ({ record = {}, storderId }) => (
  <Link
    href={`/#/customer/${record.customer.id}/show`}
    underline="none"
    style={flexStyles}
  >
    <Box display="flex" alignItems="center">
      <ProfileImage
        name={`${record.customer.first_name} ${record.customer.last_name}`}
        width="20"
        height="20"
      />
      <Box pl={1} color="#40a9ff">
        {record.customer.first_name} {record.customer.last_name}
      </Box>
    </Box>
  </Link>
);
CustomerCard.defaultProps = { label: 'Customer', addLabel: true };

export default CustomerCard;
